
import { useState } from 'react';

type Course = {
  id: string;
  course_name: string;
  course_type: string;
  description: string;
  duration_hours: number;
  price: number;
  language: string;
};

type SortConfig = {
  key: keyof Course;
  direction: 'asc' | 'desc';
} | null;

export function useCoursesSort() {
  const [sortConfig, setSortConfig] = useState<SortConfig>(null);

  const handleSort = (key: keyof Course) => {
    setSortConfig(current => {
      if (current?.key === key) {
        return {
          key,
          direction: current.direction === 'asc' ? 'desc' : 'asc'
        };
      }
      return { key, direction: 'asc' };
    });
  };

  const sortCourses = (courses: Course[]) => {
    if (!sortConfig) return courses;

    return [...courses].sort((a, b) => {
      const { key, direction } = sortConfig;
      const aValue = a[key];
      const bValue = b[key];

      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  return { sortConfig, handleSort, sortCourses };
}
